import React, {Component} from 'react';
import {GeneralContent} from '../Redux/ContentfulContentGrabber';
import {connect} from 'react-redux';
import '../CSS/App.css'
import Headroom from 'react-headroom';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import scrollToComponent from 'react-scroll-to-component';

class NavBarComponent extends Component {

    //Fetches contentful data once the component mounts
    componentWillMount() {
        this.props.fetchData();
    }

    //If the header is clicked, the page to scroll to the top
    clickedHeader(e) {
        e.preventDefault();
        scrollToComponent(this.header, {offset: 0, align: 'top', duration: 800});
    }

    //Checks to see if contentful content has returned data yet
    isContentfulContentAvailableYet() {
        return !Array.isArray(this.props.generalContent);
    }

    render() {
        let header = [];
        
        //This only creates the header content when Contentful returns the data
        if (this.isContentfulContentAvailableYet()) {
            let freshiiLogo = this.props.generalContent.items[0].fields.freshiiLogo.fields.file.url;
            let siteLogo = this.props.generalContent.items[0].fields.siteLogo.fields.file.url;
            header.push(<div className="App-header">
                <a href="https://freshii.com/" target={'blank'}>
                    <img src={freshiiLogo} className="freshiilogoArticle" draggable="false" alt="Freshii"/>
                </a>
                <a>
                    <img src={siteLogo} onClick={this.clickedHeader.bind(this)} className="siteLogo"
                         draggable="false" alt="Status"/>
                </a>
            </div>);
        }

        return (
            <ReactCSSTransitionGroup
                transitionName="example"
                transitionAppear={true}
                transitionAppearTimeout={50000}
                transitionEnter={false}
                transitionLeave={false}>
                <section ref={(section) => {
                    this.header = section;
                }}>
                    <Headroom style={{backgroundColor: "white"}} onClick={this.clickedHeader.bind(this)}>
                        {header}
                    </Headroom>
                </section>
            </ReactCSSTransitionGroup>
        );
    }
}

//Redux, gathers all Contentful Data
const mapStateToProps = (state) => {
    return {
        generalContent: state.generalContent,
        hasErrored: state.itemsHasErrored,
        isLoading: state.itemsIsLoading
    };
};

//Redux, gathers all Contentful Data
const mapDispatchToProps = (dispatch) => {
    return {
        fetchData: () => dispatch(GeneralContent())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(NavBarComponent);



// WEBPACK FOOTER //
// ./src/Components/NavBarComponent.js